/* tslint:disable */
/* eslint-disable */
export enum WorkTicketPreferredChannelEnum {
  Phone = 'PHONE',
  Email = 'EMAIL',
  Sms = 'SMS'
}
